/**
 * Created by Andrey Popov on 01.10.2026
 *
 * An expedition with a design folder is built from its own folder: res/ holds the art and the map,
 * design/ holds the designer's JSON. design/config.json names the type and what differs from the type,
 * res/units/<unit>/settings.json names the bridge type or the size of a unit and whether it can be dragged,
 * when they differ from the expedition type.
 */

const ExpeditionDesign = {
    // an expedition gets the unit families of its type: those of the last expedition of the type registered in code
    FAMILIES: {
        adventure: "laborday26",
        classic: "autumn26"
    },

    // the bridge types of settings.json: the cells are fixed, the art is drawn to fit them
    SHAPES: {
        bridge: "SquarePassableLeftAnchor",
        longbridge: "2x3Vertical",
        log: "1x4Horizontal",
        arch: "SquarePassableStrip",
        block: "Square"
    },

    list: function () {
        return Object.values(cleverapps.config.locations || {})
            .map((location) => this.get(location.id))
            .filter(Boolean);
    },

    // the location config of an expedition that names its type
    get: function (id) {
        const config = bundles[`location_${id}`] && bundles[`location_${id}`].meta.locationConfig;
        return config && config.type ? config : undefined;
    }
};

if (typeof cc === "undefined") {
    const fs = require("fs");
    const path = require("path");

    ExpeditionDesign.read = function (id, file) {
        file = path.join(__dirname, "../../..", id, file);
        try {
            return JSON.parse(fs.readFileSync(file, "utf8"));
        } catch (e) {
            throw `Can't read ${file}: ${e}`;
        }
    };

    // an expedition whose feature is off is not there, as in the game; a build has its features not resolved yet here,
    // "@debug" on the feature means debug builds only
    ExpeditionDesign.get = function (id) {
        const features = cleverapps.config.features;
        const enabled = features.includes(`expedition_${id}`) || (cleverapps.config.debugMode && features.includes(`expedition_${id}@debug`));
        if (!enabled || !fs.existsSync(path.join(__dirname, "../../..", id, "design"))) {
            return undefined;
        }

        const folder = path.join(__dirname, "../../..", id, "res/units");
        const units = {};
        fs.readdirSync(folder).filter((code) => fs.existsSync(path.join(folder, code, "settings.json"))).forEach((code) => {
            units[code] = ExpeditionDesign.read(id, `res/units/${code}/settings.json`);
        });

        return { ...ExpeditionDesign.read(id, "design/config.json"), offers: ExpeditionDesign.read(id, "design/offers.json"), units };
    };

    module.exports = ExpeditionDesign;
}

// the saved ids of the expedition's offers are kept in its offers.json
ExpeditionDesign.list().forEach((design) => {
    design.offers.filter((offer) => offer.typeId).forEach((offer) => {
        const taken = typeof cc === "undefined" && Object.keys(Offers.TYPES).find((name) => Offers.TYPES[name] === offer.typeId);
        if (taken) {
            throw `Offer id ${offer.typeId} of ${offer.id} in ${design.id}/design/offers.json is taken by ${taken}`;
        }
        Offers.TYPES[offer.id] = offer.typeId;
    });
});
